export const orderItemsCancelMutation = /* GraphQL */ `
  mutation OrderItemsCancel($input: OrderItemsCancelInput!) {
    orderItemsCancel(input: $input) {
      __typename
    }
  }
`;

export const customerAccessTokenQuery = /* GraphQL */ `
  mutation MyMutation($multipassToken: String) {
    customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
      customerAccessToken {
        expiresAt
        accessToken
      }
      customerUserErrors {
        message
        field
        code
      }
    }
  }
`;

export const customerAccessTokenCreateMutation = /* GraphQL */ `
  mutation CustomerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`;

export const customerAccessTokenCreateWithMultipassQuery = /* GraphQL */ `
  mutation MyMutation($multipassToken: String = "") {
    customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
      customerAccessToken {
        expiresAt
        accessToken
      }
      customerUserErrors {
        message
        field
        code
      }
    }
  }
`;

export const prepareOrderForRefundMutation = /* GraphQL */ `
  mutation PrepareOrderForRefund(
    $customerAccessToken: String!
    $orderId: ID!
    $lineItemIds: [String]!
  ) {
    prepareOrderForRefund(
      customerAccessToken: $customerAccessToken
      orderId: $orderId
      lineItemIds: $lineItemIds
    ) {
      id
    }
  }
`;

export const refundOrderMutation = /* GraphQL */ `
  mutation RefundOrder(
    $customerAccessToken: String!
    $orderId: ID!
    $lineItems: [RefundLineItemInput]
    $reason: String
    $comments: String
    $resolution: String
  ) {
    refundOrder(
      customerAccessToken: $customerAccessToken
      orderId: $orderId
      lineItems: $lineItems
      reason: $reason
      comments: $comments
      resolution: $resolution
    ) {
      id
      note
      totalRefundedSet {
        presentmentMoney {
          amount
          currencyCode
        }
        shopMoney {
          amount
          currencyCode
        }
      }
      shippingRefundSet {
        amount
        currencyCode
      }
    }
  }
`;
